import React, { useState } from 'react';
import { Tab, TabPanel, Tabs } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { TListingCarDetailGroupedWithIcon } from 'types/TListing';

import Classes from './CarAttributesTabs.module.scss';

const MAX_TABS = 7;
const TAB_CONTENT_COLUMNS = 2;

type TCarAttributesTabsProps = {
  attributesGroups: TListingCarDetailGroupedWithIcon[];
};

const CarAttributesTabs = ({ attributesGroups }: TCarAttributesTabsProps) => {
  const { t } = useI18nContext();
  const [activeTab, setActiveTab] = useState(0);

  if (!attributesGroups.length) {
    return null;
  }

  const tabGroups = attributesGroups.slice(0, MAX_TABS);

  return (
    <>
      <Tabs activeTab={activeTab} setActiveTab={setActiveTab}>
        {tabGroups.map((group) => (
          <Tab key={group.key} label={t(group.label ?? '')} />
        ))}
      </Tabs>

      {tabGroups.map((group, index) => (
        <TabPanel key={group.key} activeTab={activeTab} tab={index}>
          <div className={Classes.panelContainer}>
            {group.attributes.map((item) => {
              const attributeHasValues = item.values && item.values.length > 1;
              const displayValue = item.value ?? item.values?.[0];

              return attributeHasValues ? (
                <ul key={item.key} className={Classes.contentWrapper}>
                  {item.values?.map((option) => (
                    <li key={option} className={Classes.valueWithoutLabel}>
                      {option}
                    </li>
                  ))}
                  {Array.isArray(item.values) && item.values.length % TAB_CONTENT_COLUMNS === 1 && (
                    <li className={Classes.valueWithoutLabel} aria-hidden="true" role="presentation" />
                  )}
                </ul>
              ) : (
                <React.Fragment key={item.key}>
                  <div className={Classes.itemLabel}>{item.label}</div>
                  <div className={Classes.itemValue}>{`${displayValue} ${item.unit ?? ''}`}</div>
                </React.Fragment>
              );
            })}
          </div>
        </TabPanel>
      ))}
    </>
  );
};

export default CarAttributesTabs;
